'use client';

import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import { Text, HStack } from '@chakra-ui/react';

const AnnouncementBar = () => {
  return (
    <SectionContainer
      containerInnerProps={{
        backgroundColor: 'brand.50',
        paddingY: 3,
      }}
    >
      <HStack
        width="100%"
        justifyContent={{
          base: 'center',
          mobile: 'flex-start',
        }}
      >
        <SafeLink href="/all-brands/" _hover={{ textDecoration: 'none' }} cursor="pointer">
          <Text color="common.100" textStyle="body3" fontWeight="regular">
            Explore Top-Rated Korean Skincare Products
          </Text>
        </SafeLink>
      </HStack>
    </SectionContainer>
  );
};

export default AnnouncementBar;
